import { Box, Grid, Button } from "@mui/material";
import { FC, useState, useEffect } from "react";
import GoldTopBanner from "../../components/GoldTopBanner";
import { H3, Small } from "../../components/Typography";
import { useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { load, remove } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import { addBankAccount, getBankDetails, sellData } from "../../redux/actions";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import AddIcon from "@mui/icons-material/Add";
import DashboardNavbar from "../../components/DashboardNavbar";
import AddBankModel from "../../components/AddBankModel";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import SilverTopBanner from "../../components/SilverTopBanner";
const SellBreakup: FC = () => {
  let routeData = useLocation();

  const { data } = routeData.state;
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectedBank, setSelectedBank] = useState<any>("");
  const [finaldata, setFinalData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [bankData, setBankData] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getBankDetailsData();
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const getBankDetailsData = async () => {
    setLoading(true);
    let token = load("token");
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    dispatch(getBankDetails(finalUser.id, token))
      .then(async (response: any) => {
        if (response?.status === 401) {
          setLoading(false);
          return;
        }
        setBankData(response);
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const onProceed = () => {
    if (finaldata === undefined) {
      toast.error("Please select your bank.");
    } else {
      setLoading(true);
      let token: any = load("token");
      let userDetail: any = load("userData");
      let user = JSON.parse(userDetail);
      const code = user.country_code ? user.country_code : "+91";
      var newValue = code.toString().slice(1);

      var finalAPIData = {
        mobileNo: newValue + user.mobile,
        amount: data.amount,
        productId: data.productId,
        quantity: data.quantity,
        name: user.firstname + " " + user.lastname,
        bankAccountNumber: finaldata.accountNumber,
        partnerId: user?.refcode,
        bankIfscCode: finaldata.ifscCode,
        userId: user.id,
      };

      dispatch(sellData(finalAPIData, token))
        .then(async (response: any) => {
          if (response?.status === 401) {
            return;
          }
          if (response.errorMsg === "Success") {
            navigate("/success", {
              state: {
                amount: data.amount,
              },
            });
            return;
          }
          if (response.errorCode === "1011") {
            toast.error(response.errorMsg);
            setLoading(false);
            return;
          }
          setLoading(false);
          getBankDetailsData();
        })
        .catch((error: any) => {
          toast.error(error);
          setLoading(false);
        });
    }
  };

  const handleSave = (value: any) => {
    setLoading(true);
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    const data = {
      mobileNo: finalUser.mobile,
      fullName: value.fullname,
      accountNumber: value.accountNo,
      ifscCode: value.ifscCode,
      consent: "true",
      bankName: "",
      userId: finalUser.id,
    };
    let token: any = load("token");
    dispatch(addBankAccount(data, token))
      .then(async (response: any) => {
        if (response.code === 0) {
          toast.success("Bank account added sucessfully");
          handleCloseModal();
          setLoading(false);
        }
        if (response.code === 2011) {
          toast.error(response.error);
          setLoading(false);
          return;
        }
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  return (
    <>
      <DashboardNavbar />
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Box
          sx={{
            background: {
              md: "#fff",
              xs: "transparent",
            },
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
          }}
        >
          <AddBankModel
            open={openModal}
            handleClose={handleCloseModal}
            handleSave={handleSave}
            //nameValue={inputValue}
          />
          {data.productId === "gold" ? <GoldTopBanner /> : <SilverTopBanner />}

          <Grid
            xs={12}
            md={12}
            sx={{
              display: "flex",
              flexDirection: {
                md: "row",
                xs: "column",
              },
              width: "100%",
              background: "#fff",
              boxShadow: {
                md: 2,
                xs: 0,
              },
              borderRadius: 2,
              mt: 2,
              pb: 4,
              justifyContent: "space-around",
            }}
          >
            <Grid
              xs={12}
              md={5}
              sx={{
                display: "flex",
                flexDirection: "column",
                width: {
                  md: "48%",
                  xs: "100%",
                },

                pt: 2,

                pb: 2,
                pl: {
                  md: 2,
                  xs: 0,
                },
              }}
            >
              <H3
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Product Details
              </H3>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  width: "90%",
                  mt: 2,
                  boxShadow: 2,
                  borderRadius: 2,
                  pl: 2,
                  pr: 2,
                  pt: 2,
                  pb: 2,
                  justifyContent: {
                    md: "space-between",
                    xs: "center",
                  },
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {
                      md: "row",
                      xs: "column",
                    },
                    borderRadius: 2,
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      height: 40,
                      minwidth: {
                        md: 40,
                        xs: 70,
                        sm: 70,
                      },

                      border: "0.8px solid #E8E8E8",
                      borderRadius: "50%",
                      p: 2,
                    }}
                    src={
                      data.productId === "gold"
                        ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                        : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
                    }
                    alt="saas-dasboard-footer"
                  />
                  <Box
                    sx={{
                      flexDirection: "column",
                      display: "flex",
                      ml: 1,
                    }}
                  >
                    <Small
                      sx={{
                        textAlign: {
                          md: "left",
                          xs: "center",
                        },
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: 16,
                      }}
                      fontWeight={"700"}
                      color="#0C0C0C"
                    >
                      {data.productId === "gold" ? "Gold" : "Silver"}
                    </Small>
                    <Small
                      sx={{
                        mt: 0.4,
                        fontSize: 12,
                        textAlign: {
                          md: "left",
                          xs: "center",
                        },
                      }}
                      fontWeight={"600"}
                      color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                    >
                      <Small
                        sx={{
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"500"}
                        color="#000"
                      >
                        Current selling Price:
                      </Small>{" "}
                      ₹
                      <Small
                        sx={{
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"600"}
                        color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                      >
                        {data.currentSellPrice}/Gm
                      </Small>
                    </Small>
                    <Small
                      sx={{
                        mt: 0.4,
                        fontSize: 12,
                        textAlign: {
                          md: "left",
                          xs: "center",
                        },
                      }}
                      fontWeight={"600"}
                      color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                    >
                      <Small
                        sx={{
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"500"}
                        color="#000"
                      >
                        Amount to be credited in your bank:
                      </Small>{" "}
                      ₹
                      <Small
                        sx={{
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"600"}
                        color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                      >
                        {data.amount}
                      </Small>
                    </Small>
                    <Small
                      sx={{
                        mt: 0.4,
                        fontSize: 12,
                        textAlign: {
                          md: "left",
                          xs: "center",
                        },
                      }}
                      fontWeight={"600"}
                      color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                    >
                      <Small
                        sx={{
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"500"}
                        color="#000"
                      >
                        Gold quantity:{" "}
                      </Small>
                      {data.quantity} Gm
                    </Small>
                  </Box>
                </Box>
                {/* right */}
              </Box>
              <H3
                sx={{
                  fontFamily: "'Poppins', sans-serif",

                  pt: 2,
                }}
              >
                Select Bank
              </H3>

              {bankData.length === 0 ? (
                <Box
                  sx={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "95%",
                  }}
                >
                  <Button
                    disableElevation
                    disableRipple
                    size="medium"
                    sx={{
                      background: "transparent",
                      color: process.env.REACT_APP_PRIMARY_COLOR,
                      width: {
                        md: "50%",
                        xs: "100%",
                      },
                      mb: 1,
                      borderRadius: 2,
                    }}
                    onClick={handleOpenModal}
                  >
                    <AddIcon
                      style={{
                        color: process.env.REACT_APP_PRIMARY_COLOR,
                      }}
                    />
                    Add Bank
                  </Button>
                </Box>
              ) : (
                <RadioGroup
                  aria-label="address"
                  name="address"
                  value={selectedBank}
                  onChange={(event: any) => {
                    setSelectedBank(event.target.value);

                    setFinalData(bankData[event.target.value]);
                  }}
                >
                  <FormControl>
                    {bankData.map((item: any, index: number) => (
                      <FormControlLabel
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: "89%",

                          borderRadius: 2,
                          mt: 2,
                          p: 2,
                          pl: 0,
                          // justifyContent: "space-between",
                        }}
                        value={index}
                        control={<Radio />}
                        label={
                          <Small
                            sx={{
                              textAlign: "left",
                              fontFamily: "'Poppins', sans-serif",
                              fontSize: 12,
                            }}
                            fontWeight={"500"}
                            color="#0C0C0C"
                          >
                            Account No. :- {item.accountNumber} <br></br>
                            IFSC Code :- {item.ifscCode}
                          </Small>
                        }
                      />
                    ))}
                  </FormControl>
                </RadioGroup>
              )}
            </Grid>
            {/* right container */}
            <Grid
              xs={12}
              md={5}
              sx={{
                display: "flex",
                flexDirection: "column",
                width: {
                  md: "48%",
                  xs: "100%",
                },
                p: {
                  md: 1,
                  xs: 0,
                },
                //alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  color: "#fff",
                  width: {
                    md: "50%",
                    xs: "100%",
                  },
                  mb: 1,
                  mt: 2,
                  borderRadius: 2,
                }}
              >
                <Button
                  onClick={onProceed}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={{
                    background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                    color: "#fff",
                    width: {
                      md: "50%",
                      xs: "100%",
                    },
                    mb: {
                      md: 1,
                      xs: 0,
                    },
                    mt: {
                      md: 2,
                      xs: 0,
                    },
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                >
                  Proceed
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default SellBreakup;
